'use client';

import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  PUBLIC_SEARCH_DEFAULT_CONTAINS_FLAG,
  resolveDefaultQuickSearchOperator,
  setQuickSearchDefaultOperator,
} from '../quickSearchOperator';

export function useQuickSearchDefaultOperator(): string {
  const flags = useFlags();
  const flagValue = flags[PUBLIC_SEARCH_DEFAULT_CONTAINS_FLAG] as
    | boolean
    | undefined;

  return resolveDefaultQuickSearchOperator(flagValue);
}

/** Syncs the LaunchDarkly default plain-text operator into the filter module. */
export function useSyncQuickSearchDefaultOperator(): void {
  const defaultOperator = useQuickSearchDefaultOperator();

  useEffect(() => {
    setQuickSearchDefaultOperator(defaultOperator);
  }, [defaultOperator]);
}
